import "@babel/polyfill";
import "@/plugins/vuetify";
import "@/styles.css";
import "@/material-icons.css";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import { auth } from "@/firebase";
import "@/validate";

Vue.config.productionTip = false;

const unsubscribe = auth.onAuthStateChanged(firebaseUser => {
  new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      if (firebaseUser) {
        store.dispatch("auth/autoSignIn", firebaseUser);
      }
    }
  }).$mount("#app");
  unsubscribe();
});
